import { useState } from "react";
import SellerStep from "../../components/seller/SellerStep";
import { SharedButton, SharedFormField } from "../../components/shared";
import { useSellerState } from "../../js/state/sellerState";

function emptyUpgrade() {
  return { id: crypto.randomUUID(), category: "", year: "", description: "" };
}

export default function SellerUpgrades() {
  const saved = useSellerState().seller.portfolio.upgrades || {};
  const [form, setForm] = useState({
    items: saved.items?.length ? saved.items : [emptyUpgrade()],
    notes: saved.notes || "",
  });

  function updateItem(id, event) {
    const { name, value } = event.target;
    setForm((current) => ({
      ...current,
      items: current.items.map((item) => (item.id === id ? { ...item, [name]: value } : item)),
    }));
  }

  return (
    <SellerStep
      title="Upgrades"
      lead="What has already been done — with years if you have them. This is often what supports price."
      sectionKey="upgrades"
      value={form}
    >
      <section className="checklist-section">
        <h2>Completed Work</h2>
        <p className="section-help">Roof, HVAC, kitchen, baths, windows, electrical — anything a buyer or inspector will ask about.</p>
        {form.items.map((item, index) => (
          <div key={item.id} className="seller-repeat-row">
            <p className="field-label">Upgrade {index + 1}</p>
            <div className="two-col">
              <SharedFormField
                label="Category"
                name="category"
                value={item.category}
                onChange={(event) => updateItem(item.id, event)}
                placeholder="Kitchen, HVAC, roof…"
              />
              <SharedFormField
                label="Year"
                name="year"
                value={item.year}
                onChange={(event) => updateItem(item.id, event)}
                placeholder="2021"
              />
            </div>
            <SharedFormField
              label="What was done"
              name="description"
              type="textarea"
              rows={2}
              value={item.description}
              onChange={(event) => updateItem(item.id, event)}
            />
            {form.items.length > 1 ? (
              <SharedButton
                variant="ghost"
                onClick={() =>
                  setForm((current) => ({
                    ...current,
                    items: current.items.filter((entry) => entry.id !== item.id),
                  }))
                }
              >
                Remove
              </SharedButton>
            ) : null}
          </div>
        ))}
        <SharedButton
          variant="secondary"
          onClick={() => setForm((current) => ({ ...current, items: [...current.items, emptyUpgrade()] }))}
        >
          Add another upgrade
        </SharedButton>
        <SharedFormField
          label="Upgrade notes for my agent"
          name="notes"
          type="textarea"
          value={form.notes}
          onChange={(event) => setForm((current) => ({ ...current, notes: event.target.value }))}
          placeholder="Warranties still in force, permits pulled, receipts you can provide."
        />
      </section>
    </SellerStep>
  );
}
